export default {
  title: 'Edit activity',
  backButton: 'All activities',
};
